// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import IconFacebook from 'church-theme-library/components/svg/facebook.svg'
import { loop } from 'church-theme-library/utilities/objects'

// Redux:
import { getFacebookFeed } from 'church-theme-library/redux/actions/page'

class FacebookFeedApi extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getFacebookFeed() )
	}

	renderPost = ( key, item ) => {
		const { facebookURL } = this.props
		const url = `${facebookURL}posts/${item.id}`
		let className = '-item'

		return (
			<a href={ url } className={ className } target="_blank" rel="noopener" key={ key }>
				<div className="-inner">
					{ item.image.url &&
						<div className="-image-wrap">
							<div className="-image">
								<Image
									thumb={ item.image.thumb }
									thumbWebp={ item.image.thumb_webp }
									url={ item.image.url }
									srcset={ item.image.srcset }
									srcsetWebp={ item.image.srcset_webp }
									sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 700px` }
									alt={ item.image.alt }
									focalPoint={ item.image.focal_point }
									width={ item.image.width }
									height={ item.image.height }
									aspectRatio={ item.image.aspect_ratio }
								/>
							</div>
						</div>
					}

					<div className="-header">
						<div className="-source is-facebook">
							<IconFacebook />
						</div>

						<p className="-sub">{ item.date }</p>
					</div>

					<div className="-main">
						<p dangerouslySetInnerHTML={ { __html: item.content } } />
					</div>
				</div>
			</a>
		)
	}

	render() {
		const { contentId, sectionId, data, translate, facebookURL, facebookFeedById } = this.props
		const postsMarkup = loop( facebookFeedById, this.renderPost )

		return (
			<div className="section-social-feed">
				<div className="-inner">
					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="heading"
							content={ data.heading }
						/>

						<Editable
							element="p"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ data.content }
						/>

						<p className="with-button">
							<a href={ facebookURL } className="button" target="_blank" rel="noopener">{ translate( 'Visit our Facebook page' ) }</a>
						</p>
					</div>
				</div>

				<div className="-feed">
					<div className="-inner">
						{ postsMarkup }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		facebookURL: state.site.facebookURL,
		facebookFeedById: state.page.facebookFeedById
	}
}

export default localize(
	connect( mapStateToProps )( FacebookFeedApi )
)
